<template>
  <div class="container">
    <el-card>
      <div slot="header" class="clearfix">
        <span>客户家庭成员信息</span>
        <el-button-group style="float: right; padding: 3px 0">
          <el-button type="primary" size="small" @click="handleAdd">新增</el-button>
          <el-button type="danger" size="small" @click="handleMemberDel">删除</el-button>
        </el-button-group>
      </div>

      <div :v-model="data">
        <custom-member-item
          v-for="(item, index) in data"
          :key="index + '_' + item.id"
          :data="item" 
          :show-edit="item.showEdit" 
          :index="index"
          @change-show="handleMemberShow" 
          @change-save="handleMemberSave"
          @change-update="handleMemberUpdateSave"
        ></custom-member-item>
      </div>
      
    </el-card>
    <el-dialog 
      title="删除家庭成员状况"
      :visible.sync="showDel"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      :show-close="false"
      @close="handleEditFormDialogClose"
    >
      <label> 选择你要删除的选项 </label>
      <el-table
        ref="multipleTable"
        :data="data"
        tooltip-effect="dark"
        style="width: 100%"
        @selection-change="handleSelectionChange">
        <el-table-column
          type="selection"
          width="55">
        </el-table-column>
        <el-table-column
          label="全选">
          <template slot-scope="scope">{{ scope.row.role | formatRoleName}}-{{ scope.row.data ? scope.row.data.name : ''}}</template>
        </el-table-column>
      </el-table>

      <div slot="footer" class="dialog-footer">
        <el-button @click="$emit('change-show', false)">取 消</el-button>
        <el-button type="primary" @click="handleSaveDel"> 确 定 </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import CustomMemberItem from './CustomMemberItem.vue'
  const initRoleList = [
    {
      value: 'sp',
      label: '配偶'
    },
    {
      value: 'c',
      label: '子女'
    },
    {
      value: 'sep',
      label: '自己父母'
    },
    {
      value: 'spp',
      label: '对方父母'
    },
    {
      value: 'o',
      label: '其他'
    }
  ]

  export default {
    name: 'CustomMemberInfo',
    components: { CustomMemberItem  },
    props: {
      data: {
        type: Array,
        default: function () {
          return []
        }
      },
      showDel: {
        type: Boolean,
        default: false
      },
      submitSuccess: {
        type: Boolean,
        default: false
      }
    },
    filters: {
      formatRoleName(key) {
        let ret = '--'
        let g = initRoleList.find(item => item.value === key)
        if (g) {
          ret = g.label
        }
        return ret
      }
    },
    data () {
      return {
        delList: []
      }
    },
    computed: {

    },
    created() {
    },
    methods: {
      handleAdd() {            
        const item = this.data.find(k => !k.id) 
        if (!item) {
          let ff = [{showEdit: true}]
          this.data.forEach(i => ff.push(i))
          this.$emit('change-add', ff)
        }
      },
      handleMemberShow(value, index) {
        if (this.data.length > index) {
          this.$set(this.data[index], 'showEdit', value)
        }
      },
      handleMemberSave(role, value, index) {
        this.$emit('change-save', role, value)
        if (this.data.length > index && this.submitSuccess) {
          this.$set(this.data[index], 'showEdit', false)
        }
      },
      handleMemberDel() {
        this.delList = []
        this.$emit('change-show', true)
      },
      handleSaveDel() {
        this.$emit('change-del', this.delList)
      },
      handleMemberUpdateSave(value, index) {
        this.$emit('change-update', value)

        if (this.data.length > index && this.submitSuccess) {
          this.$set(this.data[index], 'showEdit', false)
        }
      },
      handleSelectionChange(val) {
        this.delList = val
      },
      handleEditFormDialogClose() {
        // this.$refs.editForm.clearValidate()
      }
    }
  }
</script>
<style scoped>
.container {
  padding: 5px;
}
</style>